"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// import moment from 'moment'
// import Pagination from '@/components/Pagination' // secondary package based on el-pagination
// import QRCode from "qrcodejs2";
var _default = {
  name: 'account:updatePassword',
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      list: null,
      passwordTemp: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      costTemp: [],
      key: 1,
      qrcodeTemp: {
        googleQrcode: null,
        agentAccount: null
      }
    };
  },
  created: function created() {},
  computed: {
    errorInfo: function errorInfo() {
      return {
        emptyOldPassword: this.$t('SMS.oldPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyNewPassword: this.$t('SMS.newPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPassword: this.$t('SMS.confirmPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this = this;

      var checkPasswordFormat = function checkPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyNewPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkPassword = function checkPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyConfirmPassword));
        }

        if (_this.passwordTemp.newPassword !== value) {
          return callback(new Error(_this.errorInfo.organizationManagementMessage14));
        }

        return callback();
      };

      var checkOldPassword = function checkOldPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyOldPassword));
        }

        return callback();
      };

      return {
        oldPassword: [{
          required: true,
          validator: checkOldPassword,
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          validator: checkPasswordFormat,
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          validator: checkPassword,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    doResetTemp: function doResetTemp() {
      var _this2 = this;

      this.passwordTemp = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.$nextTick(function () {
        return _this2.$refs["dataForm"] ? _this2.$refs["dataForm"].clearValidate() : null;
      });
    },
    doUpdatePassword: function doUpdatePassword() {
      if (this.$store.getters.isAdmin) {
        this.updateAdminPassword();
      }

      if (this.$store.getters.isAgent) {
        this.doUpdatePasswordForAgent();
      }

      if (this.$store.getters.isMerchant) {
        this.doUpdatePasswordForMerchant();
      }
    },
    updateAdminPassword: function updateAdminPassword() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("user", "password/update", null, _this3.passwordTemp).then(function (res) {
            if (res.code === 200) {
              _this3.$notify({
                title: _lang.default.t('message.message57'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this3.doResetTemp();
              }, 1 * 1000);
            }

            ;

            if (res.code === 500) {
              _this3.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this3.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    },
    doUpdatePasswordForAgent: function doUpdatePasswordForAgent() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("agentUser", "password/update", null, _this4.passwordTemp).then(function (res) {
            if (res.code === 200) {
              _this4.$notify({
                title: _lang.default.t('message.message57'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this4.doResetTemp();
              }, 1 * 1000);
            }

            ;

            if (res.code === 500) {
              _this4.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this4.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    },
    doUpdatePasswordForMerchant: function doUpdatePasswordForMerchant() {
      var _this5 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("organizationUser", "password/update", null, _this5.passwordTemp).then(function (res) {
            if (res.code === 200) {
              _this5.$notify({
                title: _lang.default.t('message.message57'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this5.doResetTemp();
              }, 1 * 1000);
            }

            ;

            if (res.code === 500) {
              _this5.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this5.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    }
  }
};
exports.default = _default;